import Cookies from "js-cookie"

export const setAccessToken = (token) => {
  Cookies.set('auth-token', token, { expires: 7})
}

export const getAccessToken = () => {
    return Cookies.get('auth-token')
}